import { subscribeConsent, canMeasureMarketing } from "../measurement/consent";
const requests = new Set<AbortController>();
subscribeConsent(() => { if (!canMeasureMarketing()) { for (const request of requests) request.abort(); requests.clear(); } });
import { config } from "../config";

export type MetaCustomEventName = "QuizStarted" | "QuizMidpointReached" | "EmailStepViewed" | "PaywallViewed";
export type MetaWebsiteEventName = "PageView" | "ViewContent" | "InitiateCheckout" | MetaCustomEventName;
export type MetaContentName = "slim_results" | "slim_app_introduction";

type SendMetaWebsiteEventRequest = {
  eventName: MetaWebsiteEventName;
  eventId: string;
  externalId?: string | null;
  fbp?: string | null;
  fbc?: string | null;
  contentId?: string;
  promoCode?: string;
  contentName?: MetaContentName;
  currency?: string;
  value?: number;
};

export const sendMetaWebsiteEvent = (request: SendMetaWebsiteEventRequest): void => {
  if (!config.enableMarketing) return;
  try {
    const controller = new AbortController(); requests.add(controller);
    void fetch(`${config.apiBaseUrl}/api/meta-tracking/website-event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
      analyticsConsent: "granted",
        eventName: request.eventName,
        eventId: request.eventId,
        ...(request.externalId ? { externalId: request.externalId } : {}),
        ...(request.fbp ? { fbp: request.fbp } : {}),
        ...(request.fbc ? { fbc: request.fbc } : {}),
        ...(request.contentId ? { contentId: request.contentId } : {}),
        ...(request.promoCode ? { promoCode: request.promoCode } : {}),
        ...(request.contentName ? { contentName: request.contentName } : {}),
        ...(request.currency ? { currency: request.currency } : {}),
        ...(request.value !== undefined ? { value: request.value } : {})
      }),
      signal: controller.signal,
      keepalive: true
    }).catch(() => {}).finally(() => requests.delete(controller));
  } catch {
    // Fire-and-forget — never block the user.
  }
};
